import { Injectable } from '@angular/core';
import { QueryOptionsAlone } from 'apollo-angular/types';
import { map } from 'rxjs/operators';
import { FetchCardLinksGQL } from 'src/graphql/generated/graphql.generated';
import { StoreService } from 'src/store/store.service';

@Injectable({
  providedIn: 'root',
})
export class CardLinkFetchService {
  constructor(private _gql: FetchCardLinksGQL, private _store: StoreService) {}

  public fetchAllByFromCardId(fromCardId: string, options?: QueryOptionsAlone<any>) {
    return this._store
      .upsertEntitiesFromGraphQL(this._gql, { filter: { fromCardId } }, options)
      .pipe(map((res) => res.data?.cardLinks?.all?.items));
  }
  public fetchAllByToCardId(toCardId: string, options?: QueryOptionsAlone<any>) {
    return this._store
      .upsertEntitiesFromGraphQL(this._gql, { filter: { toCardId } }, options)
      .pipe(map((res) => res.data?.cardLinks?.all?.items));
  }
}
